import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Picker } from './Picker';
export const GenderPicker = ({ label = 'Gender', placeHolder = 'Please Select Gender', genders = [], ...props }) => {
    const genderItems = useMemo(() => {
        const genderData = [...genders];
        genderData.unshift({ label: placeHolder, value: undefined });
        return genderData;
    }, []);
    return _jsx(Picker, { label: label, items: genderItems, ...props });
};
